export default __webpack_public_path__ + "eca8d530.png";